<template>
  <section id="completeddevelopment" class="bg-dark text-white">
    <!-- <v-container fluid fill-height> -->
      <v-layout row wrap>
        <v-flex hover v-for="item in projects" :key="item.name" v-bind="{ [`xs${cardFlex * 3}`]: true, [`md${cardFlex}`]: true }" xs12 sm6>
          <v-card hover>
            <v-card-title primary-title>
              <div style="width: 100%;text-align: center; height: 15vh;">
                <h3 class="headline mb-0">{{ item.name }}</h3>
                <div>{{ item.address }}</div>
                <div>{{ item.properties }}</div>
                <div>Completed {{ item.completed | longMonthYearFormat }}</div>
                <!-- <div>Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</div> -->
              </div>
            </v-card-title>
            <v-card-actions>
              <v-btn flat color="orange" icon><v-icon>share</v-icon></v-btn>
              <v-btn flat color="orange" icon><v-icon>info</v-icon></v-btn>
            </v-card-actions>
            <!-- <v-container>
              <v-layout row wrap justify-center>
                <v-flex flat>
                  <table>
                    <tr>
                      <td><p><v-icon class="project-icon" color="orange darken-2">{{ "fa fa-diamond" }}</v-icon></p></td>
                    </tr>
                    <tr>
                      <td><p class="project-headline">{{ item.name }}</p></td>
                    </tr>
                    <tr>
                      <td><p class="project-detail">{{ item.address }}</p></td>
                    </tr>
                    <tr>
                      <td><p class="project-detail">{{ item.built }}</p></td>
                    </tr>
                    <tr>
                      <td><p class="project-completed">{{ item.completed }}</p></td>
                    </tr>
                  </table>
                </v-flex>
              </v-layout>
            </v-container> -->
          </v-card>
        </v-flex>
      </v-layout>
    <!-- </v-container>  -->
  </section>
</template>

<script>
import Api from '@/api'

export default {
  data () {
    return {
      cardFlex: 4,
      projects: []
    }
  },
  beforeMount () {
    this.getDevData()
  },
  methods: {
    getDevData () {
      const path = '/completed-dev'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.projects = response.data.completeddev
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
p {
  text-align: center;
  /*font-size: 11pt;*/
  line-height: 2.2vh;
}
table {
  width: 100%;
}
td {
  text-align: center;
  vertical-align: middle;
}
.project-icon {
  font-size: 2vmax;
}
.project-headline {
  font-size: 1.3vmax;
}
.project-detail {
  font-size: 1vmax;
}
.project-completed {
  font-size: 1.2vmax;
}
</style>


// WEBPACK FOOTER //
// src/components/CompletedDevelopment.vue